// extracted by mini-css-extract-plugin
export default {"container":"styles_container__SXtQ+","secondarySidebar":"styles_secondarySidebar__yNyKF","navLink":"styles_navLink__ME+MM","content":"styles_content__1yM8P"};